import { API } from "../../apiSlice";

export const getUserTotalDepositsApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    getUserTotalDeposits: builder.query({
      query: () => {
        return {
          url: "users/total-deposits",
        };
      },
    }),
  }),
});

export const { useGetUserTotalDepositsQuery } = getUserTotalDepositsApiSlice;
